module.exports = __webpack_public_path__ + "static/img/20231208_03.7d5bbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_03.png
// module id = zw3M
// module chunks = 0